import { useEffect, useCallback } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import {
  RPM_FETCH_UNIFIED_SUMMARY_BEGIN,
  RPM_FETCH_UNIFIED_SUMMARY_SUCCESS,
  RPM_FETCH_UNIFIED_SUMMARY_FAILURE,
  RPM_FETCH_UNIFIED_SUMMARY_DISMISS_ERROR,
} from './constants';
import config from '../../../common/config';
import axios from 'axios'
import { createAxiosConfigWithAuth } from '../../../common/apiHelpers';


export function fetchUnifiedSummary(args = { page: 1 }) {
  return (dispatch, getState) => { // optionally you can have getState as the second argument
    dispatch({
      type: RPM_FETCH_UNIFIED_SUMMARY_BEGIN,
    });

    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.get(
        `${config.apiRootUrl}/rpm/unified-summary/`,
        {
          params: args,
          ...createAxiosConfigWithAuth(getState()),
        }
      );
      doRequest.then(
        (res) => {
          console.log('unifiedSummary success', res.data);
          dispatch({
            type: RPM_FETCH_UNIFIED_SUMMARY_SUCCESS,
            data: res.data,
          });
          resolve(res.data);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          dispatch({
            type: RPM_FETCH_UNIFIED_SUMMARY_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissFetchUnifiedSummaryError() {
  return {
    type: RPM_FETCH_UNIFIED_SUMMARY_DISMISS_ERROR,
  };
}

export function useFetchUnifiedSummary() {
  const dispatch = useDispatch();

  const { fetchUnifiedSummaryPending, fetchUnifiedSummaryError, unifiedSummary } = useSelector(
    state => ({
      fetchUnifiedSummaryPending: state.rpm.fetchUnifiedSummaryPending,
      fetchUnifiedSummaryError: state.rpm.fetchUnifiedSummaryError,
      unifiedSummary: state.rpm.unifiedSummary,
    }),
    shallowEqual,
  );

  const boundAction = useCallback((...args) => {
    return dispatch(fetchUnifiedSummary(...args));
  }, [dispatch]);

  const boundDismissError = useCallback(() => {
    return dispatch(dismissFetchUnifiedSummaryError());
  }, [dispatch]);

  return {
    unifiedSummary,
    fetchUnifiedSummary: boundAction,
    fetchUnifiedSummaryPending,
    fetchUnifiedSummaryError,
    dismissFetchUnifiedSummaryError: boundDismissError,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case RPM_FETCH_UNIFIED_SUMMARY_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        unifiedSummaryPending: true,
        unifiedSummaryError: null,
      };

    case RPM_FETCH_UNIFIED_SUMMARY_SUCCESS:
      // The request is success
      return {
        ...state,
        unifiedSummaryPending: false,
        unifiedSummaryError: null,
        unifiedSummary: action.data,
      };

    case RPM_FETCH_UNIFIED_SUMMARY_FAILURE:
      // The request is failed
      return {
        ...state,
        unifiedSummaryPending: false,
        unifiedSummaryError: action.data.error,
      };

    case RPM_FETCH_UNIFIED_SUMMARY_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        unifiedSummaryError: null,
      };

    default:
      return state;
  }
}
